








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { AdminInvoiceRoute } from '@/modules/invoice/routes/admin-invoice.route'
import { InvoiceCollectionModelInAdmin } from '@/modules/invoice/models/invoice-collection.model'
import ActionShowButton from '@/modules/shared/components/shared/table/action/ActionShowButton.vue'

@Component({
  components: {
    BaseButton,
    ActionShowButton
  }
})
export default class AdminInvoiceActions extends Vue {
  constructor(
    private readonly routes: AdminInvoiceRoute
  ) {
    super()
  }

  @Prop() invoice!: InvoiceCollectionModelInAdmin
  @Prop() withData!: any

}

